export default "__VITE_ASSET__DKZ6aDR5__"